import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../../../../../libs/environment/environment';
import { CrmAuthCookieService } from '../pages/auth/services/crm-auth-cookie.service';

const PUBLIC_AUTH_ENDPOINTS = [
  '/v1/business/auth/login',
  '/v1/business/auth/verify-2fa',
  '/v1/business/auth/resend-2fa',
  '/v1/business/auth/refresh',
  '/v1/business/auth/logout',
];

function isApiRequest(url: string, apiBaseUrl: string): boolean {
  return url.startsWith(apiBaseUrl);
}

function isPublicAuthRequest(url: string): boolean {
  const normalizedUrl = url.toLowerCase().split('?')[0];
  return PUBLIC_AUTH_ENDPOINTS.some((endpoint) => normalizedUrl.endsWith(endpoint));
}

export const crmAuthInterceptor: HttpInterceptorFn = (req, next) => {
  const apiBaseUrl = environment.apiBaseUrl.replace(/\/$/, '');

  if (!isApiRequest(req.url, apiBaseUrl) || isPublicAuthRequest(req.url)) {
    return next(req);
  }

  if (req.headers.has('Authorization')) {
    return next(req);
  }

  const authCookieService = inject(CrmAuthCookieService);
  const accessToken = authCookieService.getAccessToken();
  if (!accessToken) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: {
        Authorization: `Bearer ${accessToken}`,
      },
    }),
  );
};